import { IOneDrivePickerItem } from "../OneDrivePickerField";
import { getFileImage } from "@/utils/generic";
import { X } from "lucide-react";
import { Badge } from "@/components/shadcn/badge";
import { Button } from "@/components/shadcn/button";
import ImageFallback from "@/components/ImageWithFallback";

export const OneDrivePickerSelectedItem = ({
  item,
  tempSelectedItems,
  setTempSelectedItems,
}: {
  item: IOneDrivePickerItem;
  tempSelectedItems: IOneDrivePickerItem[];
  setTempSelectedItems: (items: IOneDrivePickerItem[]) => void;
}) => {
  return (
    <Badge
      variant="outline"
      className="max-w-64 px-2.5 py-1 text-sm font-normal"
    >
      <span className="relative size-3.5 shrink-0">
        <ImageFallback
          src={
            item.content_type === "folder"
              ? getFileImage("folder")
              : getFileImage(item.content_type)
          }
          alt={`${item.content_type ?? "file"} icon`}
          fill
        />
      </span>
      <span className="min-w-0 truncate">{item.name}</span>
      <Button
        aria-label="Remove"
        className="ml-1 h-2 w-2 bg-transparent"
        size="iconxs"
        variant="subtle"
        onClick={(e) => {
          e.stopPropagation();
          setTempSelectedItems(
            tempSelectedItems.filter((i) => i.id !== item.id)
          );
        }}
      >
        <X className="h-2 w-2" strokeWidth="1.33px" />
      </Button>
    </Badge>
  );
};
